import {TabsReducer} from "../../../../common/tabs/tabs.reducer";
import {IDS} from "../adm-categorisation-action-id.constants";
export const admCatCentersTabs = {
    [IDS.app_administration_categorisation_centers]: Object.assign(TabsReducer(), {
        tabs: [
            {
                state: IDS.app_administration_categorisation_centers_grid,
                title: 'Centers',
                visible: true,
                disabled: false,
                loading: false,
                // buttons: {
                //     execute: {label: 'Add Center Type'}
                // },
            },
            {
                state: IDS.app_administration_categorisation_centers_details,
                title: 'Details',
                visible: false,
                disabled: false,
                loading: false
            },
            {
                state: IDS.app_administration_categorisation_centers_modules,
                title: 'Active Modules Presets',
                visible: false,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Update'}
                },
            },
        ]
    }),
}